const languageConstant = {
  en: {
    search: "Search",
    placeholder: "Best thriller movie to watch",
  },
  marathi: {
    search: "शोधा",
    placeholder: "पाहण्यासाठी सर्वोत्तम थ्रिलर चित्रपट",
  },
  hindi: {
    search: "खोज",
    placeholder: "देखने लायक सर्वश्रेष्ठ थ्रिलर फिल्म",
  },
  spanish: {
    search: "Buscar",
    placeholder: "La mejor película de suspenso para ver.",
  },
  french: {
    search: "Recherche",
    placeholder: "Meilleur film thriller à voir",
  },
};

export default languageConstant;
